import React, { useEffect, useState } from 'react'
import SubscriptionUI from '../Components/SubscriptionUIComponent'
import { SubscriptionPlanResponse } from '../Types/SubscriptionPlanType';
import { getAllSubscriptionPlans } from '../Services/SubscriptionPlanService';

function SubscriptionPage() {

  const [subscriptionPlans, setSubscriptionPlans] = useState<SubscriptionPlanResponse[]>([]);
  const [filteredCandidates, setFilteredCandidates] = useState<SubscriptionPlanResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");



    useEffect(() => {
  const fetchCandidates = async () => {
    try {
      const response = await getAllSubscriptionPlans();
      if (response.success) {
        setSubscriptionPlans(response.data);
      }
    } catch (err) {
      setError("Failed to load subscription plans");
    } finally {
      setLoading(false);
    }
  };

  fetchCandidates();
}, []);

  return (
    <div>
        <SubscriptionUI plans={subscriptionPlans} onSelect={() => {}} />
    </div>
  )
}

export default SubscriptionPage